import template from './precall-test-button.html';
import angular from 'angular';
class PrecallTestButtonController {
    constructor(VideoProviderFactory, preCallLauncher, trackingFactory) {
        this.VideoProviderFactory = VideoProviderFactory;
        this.preCallLauncher = preCallLauncher;
        this.trackingFactory = trackingFactory;
    }
    preCallTest(e) {
        this.trackingFactory.global.trackButtonClick({
            context: null,
            button_action: 'opens pre-call test',
            button_text: 'pre-call test',
            button_type: 'button',
        });
        this.preCallLauncher.preCallTest(e);
    }
}
const precallTestButton = {
    template,
    bindings: {
        isPatient: '<',
    },
    controller: PrecallTestButtonController,
};
export default angular
    .module('doxy.videoChat.common.components.precallTestButton', [])
    .component('precallTestButton', precallTestButton).name;
